(function() {
	"use strict"

	angular.module( "ATMGurus" )

	.directive( "prevent", function() {
		return {
			restrict: "A",
			link: function( scope, ele, attrs ) {
				ele.bind( "click", function( e ) {
					e.preventDefault();
					return false;
				})
			}
		}
	})

})()


// WEBPACK FOOTER //
// ./src/app/directives/prevent.js